import instance from "../../axios/axios-user";
import { ReactionsProps } from "../../redux/slices/reactions/Reactions";
import { API_PATHS } from "../api_paths";

const addAReactionToAPost = (
  payload: ReactionsProps.AddReactionToAPostPayload
) =>
  instance.post(
    `${API_PATHS.postReactions.addAReactionToAPost}/${payload.post_id}/reactions`,
    payload
  );

const getTotalReactionsForAPost = ({
  post_id,
}: ReactionsProps.GetTotalReactionsForAPostPayload) =>
  instance(
    `${API_PATHS.postReactions.getTotalReactionsForAPost}/${post_id}/reactions/total`
  );

const updateAReactionToAPost = (
  payload: ReactionsProps.UpdateAReactionToAPostPayload
) => {
  const { post_id, reaction_id, reaction_type } = payload;

  return instance.put(
    `${API_PATHS.postReactions.updateAReactionToAPost}/${post_id}/reactions/${reaction_id}`,
    { reaction_type }
  );
};

const removeAReactionFromAPost = (
  payload: ReactionsProps.RemoveAReactionFromAPostPayload
) =>
  instance.delete(
    `${API_PATHS.postReactions.removeAReactionFromAPost}/${payload.post_id}/reactions/${payload.reaction_id}`
  );

const getSystemCuratedReactionTypes = () =>
  instance.get(API_PATHS.postReactions.getSystemCuratedReactionTypes);

export const POST_REACTIONS = {
  addAReactionToAPost,
  getTotalReactionsForAPost,
  removeAReactionFromAPost,
  updateAReactionToAPost,
  getSystemCuratedReactionTypes,
};
